import types from './constants';

export default {
  [types.DYSLEXIA_SORT]: (sort) => ({
   type: types.DYSLEXIA_SORT,
   sort
  }),
  [types.DYSLEXIA_PENDING]: () => ({
   type: types.DYSLEXIA_PENDING,
  }),
  [types.DYSLEXIA_COMPLETE]: (report) => ({
   type: types.DYSLEXIA_COMPLETE,
   report,
  }),
  [types.DYSLEXIA_ERROR]: (error) => ({
   type: types.DYSLEXIA_ERROR,
   error
  }),
  [types.DYSLEXIA_CACHE_SAVE]: (payload) => ({
    type: types.DYSLEXIA_CACHE_SAVE,
    payload
   }),
}